/* eslint-disable @nx/enforce-module-boundaries */
'use client';
import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Text } from '@mybridge/ui/text';
import { Button } from '@mybridge/ui/button';
import { Container } from '@mybridge/ui/container';
import { Box, HStack, Stack, VStack } from '@mybridge/ui/layout';
import { isMobile } from 'react-device-detect';
import style from './create-job-layout.module.scss';
import {
  BackArrow,
  BackArrowRTL,
  Brifecase,
  Currency,
  DesktopIcon,
  Industry,
  JobPlaceholderIcon,
  JobsIcon,
  MobileIcon,
} from '@mybridge/icons';
import { useRouter } from 'next/router';
import {
  Avatar,
  Card,
  Heading,
  Scrollable,
  Image,
  Flex,
  Tag,
  IconButton,
  Tooltip,
} from '@mybridge/ui';
import { CompanyIcon } from '@mybridge/icons/Company';
import { CreateJobsProvider, CreateJobsContext } from './context';
import { formatLocation, getUserLocation } from 'v4/lib/commons';
import { currencyFormatter } from 'v4/components/utils';
import _ from 'lodash';
import { ExpandIcon, ExpandIconNew } from '@mybridge/icons/Expand';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';
import { BENEFITS } from 'v4/lib/data';
// const sectionText = {
//   1: 'Post jobs in quick and easy steps.',
//   2: 'Benefits',
//   3: 'How would you like people to apply?',
//   4: 'Job Description',
// };

export const Layout = ({ children }) => {
  const {
    section,
    setSection,
    jobDetails,
    selectCompany,
    EMPLOYMENT_CHOICES,
    WORKPLACE_TYPE,
    isEdit,
    setWindowMaximise,
    windowMaximise,
  } = useContext(CreateJobsContext);
  const router = useRouter();
  const { t } = useTranslator();
  const direction = useDirection();
  const sectionText = {
    1: t('jobs.postJobsQuickSteps') || 'Post jobs in quick and easy steps.',
    2: t('jobs.benefits') || 'Benefits',
    3: t('jobs.howWouldYouLikeToApply') || 'How would you like people to apply?',
    4: t('jobs.jobDescription') || 'Job Description',
  };
  const [previewMobile, setPreviewMobile] = useState(false);
  // console.log('jobDetails', jobDetails);
  // console.log('section', section);

  return (
    <>
      {isEdit ? (
        <Stack alignItems="flex-start">
          <Container maxW="1220px">{children}</Container>
        </Stack>
      ) : (
        <Stack
          spacing={8}
          alignItems="flex-start"
          direction={['column', 'row']}
          justifyContent="center"
          p={3}
        >
          {windowMaximise && section === 4 ? (
            <>
              <Stack w={['100%', '90%', '90%']} // Ensure consistent width
                justifyContent="center"
                mb={5}
                border="1px solid #D9D9D9" // Add border
                borderRadius="8px" // Optional: Rounded corners
              >
                <Container maxW={previewMobile ? '530px' : '100%'}>
                  <Card
                    p={3}
                    variant="thinBorderedCard"
                    m={1}
                    minH="calc(100vh - 100px)"
                  >
                    <VStack gap={3} alignItems="flex-start" p={3}>
                      <HStack justifyContent="space-between" w="100%">
                        {section === 1 ? (
                          <Button
                            variant="transparent"
                            leftIcon={<BackArrow color="#868585" />}
                            color="#868585"
                            onClick={() => router.back()}
                            p={0}
                          >
                            {t('buttons.back') ||  "Back"}
                          </Button>
                        ) : (
                          <Text color="#868585">{t('createPage.step') || "Step"} {section} {t('myDisk.of') || "of"} 4</Text>
                        )}
                        {section === 4 && (
                          <Tooltip label={windowMaximise ? t('jobs.minimise') || 'Minimise' : t('jobs.maximise') || "Maximise"}>
                            <IconButton
                              icon={<ExpandIconNew />}
                              onClick={() => setWindowMaximise((prev) => !prev)}
                              size="sm"
                              variant="transparent"
                            />
                          </Tooltip>
                        )}
                      </HStack>
                      {section === 1 ? (
                        <Heading
                          color="brandPrimary.500"
                          fontSize="28px"
                          fontWeight="400"
                        >
                          {t('pageJobs.postJob') || "Post Job"}
                        </Heading>
                      ) : (
                        <Heading
                          color="brandPrimary.500"
                          fontSize="28px"
                          fontWeight="400"
                        >
                          {sectionText[section]}
                        </Heading>
                      )}
                      {section === 1 && (
                        <Text fontSize="17px" color="brandGray.700">
                          {sectionText[section]}
                        </Text>
                      )}
                      {children}
                    </VStack>
                  </Card>
                </Container>
              </Stack>
            </>
          ) : (
            <>
            {isMobile ? (
              <Box w="100%">
                <Card
                  variant="thinBorderedCard"
                  m={1}
                >
                  <VStack gap={3} alignItems="flex-start">
                    <HStack justifyContent="space-between" w="100%">
                      {section === 1 ? (
                        <Button
                          variant="transparent"
                          leftIcon={direction === 'rtl' ? <BackArrowRTL color="#868585" /> : <BackArrow color="#868585" />}
                          color="#868585"
                          onClick={() => router.back()}
                          p={0}
                        >
                          {t('buttons.back') ||  "Back"}
                        </Button>
                      ) : (
                        <Text color="#868585">{t('createPage.step') || "Step"} {section} {t('myDisk.of') || "of"} 4</Text>
                      )}
                      {section === 4 && (
                        <Tooltip label={t('jobs.maximise') || "Maximise"}>
                          <IconButton
                            icon={<ExpandIconNew />}
                            onClick={() => setWindowMaximise((prev) => !prev)}
                            size="sm"
                            variant="transparent"
                          />
                        </Tooltip>
                      )}
                    </HStack>
                    {section === 1 ? (
                      <Heading
                        color="brandPrimary.500"
                        fontSize="28px"
                        fontWeight="400"
                      >
                        {t('pageJobs.postJob') || "Post Job"}
                      </Heading>
                    ) : (
                      <Heading
                        color="brandPrimary.500"
                        fontSize="28px"
                        fontWeight="400"
                      >
                        {sectionText[section]}
                      </Heading>
                    )}
                    {section === 1 && (
                      <Text fontSize="18px" color="brandGray.700">
                        {sectionText[section]}
                      </Text>
                    )}
                    {children}
                  </VStack>
                </Card>
              </Box>
            ) : (
              <Scrollable
                pos="sticky"
                top="75px"
                w={['100%', '44%', '44%']}
                border="1px solid #D9D9D9" // Add border
                borderRadius="8px" // Optional: Rounded corners
              >
                <Card
                  variant="thinBorderedCard"
                  m={1}
                >
                  <VStack gap={3} alignItems="flex-start" p={3}>
                    <HStack justifyContent="space-between" w="100%">
                      {section === 1 ? (
                        <Button
                          variant="transparent"
                          leftIcon={direction === 'rtl' ? <BackArrowRTL color="#868585" /> : <BackArrow color="#868585" />}
                          color="#868585"
                          onClick={() => router.back()}
                          p={0}
                        >
                          {t('buttons.back') ||  "Back"}
                        </Button>
                      ) : (
                        <Text color="#868585">{t('createPage.step') || "Step"} {section} {t('myDisk.of') || "of"} 4</Text>
                      )}
                      {section === 4 && (
                        <Tooltip label={t('jobs.maximise') || "Maximise"}>
                          <IconButton
                            icon={<ExpandIconNew />}
                            onClick={() => setWindowMaximise((prev) => !prev)}
                            size="sm"
                            variant="transparent"
                          />
                        </Tooltip>
                      )}
                    </HStack>
                    {section === 1 ? (
                      <Heading
                        color="brandPrimary.500"
                        fontSize="28px"
                        fontWeight="400"
                      >
                        {t('pageJobs.postJob') || "Post Job"}
                      </Heading>
                    ) : (
                      <Heading
                        color="brandPrimary.500"
                        fontSize="28px"
                        fontWeight="400"
                      >
                        {sectionText[section]}
                      </Heading>
                    )}
                    {section === 1 && (
                      <Text fontSize="18px" color="brandGray.700">
                        {sectionText[section]}
                      </Text>
                    )}
                    {children}
                  </VStack>
                </Card>
              </Scrollable>
            )}
             { !isMobile && <Stack w={['100%', '44%', '44%']} // Ensure consistent width
                justifyContent="center"
                mb={5}
                border="1px solid #D9D9D9" // Add border
                borderRadius="8px" // Optional: Rounded corners
              >
                <Container maxW={previewMobile ? '530px' : '1000px'}>
                  <Card
                    p={3}
                    variant="thinBorderedCard"
                    m={1}                  >
                    <VStack align="stretch" gap={6}>
                      <HStack
                        w="100%"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <Text fontSize="14px" color="brandPrimary.500">
                          {previewMobile ? t('createPage.mobilePreview') || 'Mobile Preview' : t('createPage.desktopPreview') || 'Desktop Preview'}
                        </Text>

                        <HStack>
                          <Tooltip label={t('jobs.desktopView') || "Desktop view"}>

                            <IconButton
                              icon={
                                <DesktopIcon
                                  color={previewMobile ? '#868585' : '#3D5A80'}
                                />
                              }
                              variant="transparent"
                              size="sm"
                              onClick={() => setPreviewMobile(false)}
                            />
                          </Tooltip>
                          <Tooltip label={t('jobs.mobileView') || "Mobile view"}>
                            <IconButton
                              icon={
                                <MobileIcon
                                  color={!previewMobile ? '#868585' : '#3D5A80'}
                                />
                              }
                              variant="transparent"
                              size="sm"
                              onClick={() => setPreviewMobile(true)}
                            />
                          </Tooltip>
                        </HStack>
                      </HStack>

                      <Image
                        src={
                          selectCompany && selectCompany?.image
                            ? selectCompany?.image
                            : ''
                        }
                        alt={selectCompany ? selectCompany?.name : t('createPage.pageName') || 'Page name'}
                        w="140px"
                        h="140px"
                        borderRadius="full"
                        fallback={
                          <Flex
                            p={2}
                            bg="#D9D9D9"
                            width="130px"
                            height="130px"
                            justifyContent="center"
                            alignItems="center"
                            borderRadius="full"
                          >
                            <JobPlaceholderIcon width="100px" height="60px" />
                          </Flex>
                        }
                      />
                      <Box>
                        <Heading as="h2" fontSize="18px" textTransform="capitalize" fontWeight="400">
                          {jobDetails?.title ? jobDetails?.title : t('jobs.jobTitle') || 'Job Title'}
                        </Heading>
                        <Text fontSize="16px" fontWeight="400">
                          {selectCompany ? selectCompany?.name : t('createPage.pageName') || 'Page name'}
                        </Text>
                        <Text fontSize="15px" fontWeight="400">
                          {jobDetails?.city
                            ? formatLocation(jobDetails)
                            : t('createJob.jobLocation') || 'Job Location'}
                        </Text>
                      </Box>

                      <VStack align="stretch" gap={0}>
                        {jobDetails?.compensation_range_min_amt ? <HStack mb={1} alignItems="center">
                          <Currency />{' '}
                          {jobDetails?.compensation_range_min_amt ? (
                            jobDetails?.compensation_range_max_amt !== null &&
                              jobDetails?.compensation_range_max_amt > 0 ? (
                              <Text>
                                {currencyFormatter(
                                  jobDetails?.compensation_range_min_amt,
                                  jobDetails?.currency_choice
                                    ? jobDetails?.currency_choice
                                    : 'USD'
                                )}{' '}
                                to{' '}
                                {currencyFormatter(
                                  jobDetails?.compensation_range_max_amt,
                                  jobDetails?.currency_choice
                                    ? jobDetails?.currency_choice
                                    : 'USD'
                                )}{' '}
                                {_.capitalize(jobDetails?.payment_choice)}
                                {jobDetails?.plus_comission &&
                                  ` (${t('createJob.withCommission') || "with commission"})`}
                              </Text>
                            ) : (
                              <Text>
                                {currencyFormatter(
                                  jobDetails?.compensation_range_min_amt,
                                  jobDetails?.currency_choice
                                    ? jobDetails?.currency_choice
                                    : 'USD'
                                )}{' '}
                                {_.capitalize(jobDetails?.payment_choice)}
                                {jobDetails?.plus_comission &&
                                  ` (${t('createJob.withCommission') || "with commission"})`}
                              </Text>
                            )
                          ) : (
                            <Text>{t('jobs.salary') || "Salary"}</Text>
                          )}
                        </HStack> : <></>}

                        {jobDetails?.benefits ? <HStack mb={1} alignItems="center">
                          {jobDetails?.benefits?.length && <Industry />}{' '}
                          {/* <Text>
                            {jobDetails?.benefits
                              ? jobDetails?.benefits
                                ?.map?.((b) => (b?.name ? b?.name : b))
                                ?.join(', ')
                              : t('jobs.benefit') || 'Benefit'}
                          </Text> */}
                          <Text>
                            {jobDetails?.benefits && jobDetails?.benefits.length
                              ? jobDetails?.benefits
                                  ?.map?.((b) => {
                                    const benefitLabel = b?.name ? b?.name : b;
                                    // Find the benefit in the BENEFITS array to get its translationKey
                                    const benefitObj = BENEFITS.find(benefit => benefit.label === benefitLabel);
                                    // Return translated text if translationKey exists, otherwise use the original label
                                    return benefitObj?.translationKey ? t(benefitObj.translationKey) || benefitLabel : benefitLabel;
                                  })
                                  ?.join(', ')
                              : t('jobs.benefit') || 'Benefit'}
                          </Text>
                        </HStack> : <></>}

                        <HStack mb={1} alignItems="center">
                          <Brifecase />{' '}
                          <Text>
                            {/* {jobDetails?.employment_type
                              ? EMPLOYMENT_CHOICES?.find(
                                (ec) =>
                                  ec.value == jobDetails?.employment_type
                              )?.label
                              : t('jobs.employmentType') || 'Employment type'}{' '} */}
                            {jobDetails?.employment_type
                              ? t(EMPLOYMENT_CHOICES?.find(
                                  (ec) => ec.value == jobDetails?.employment_type
                                )?.translationKey) || EMPLOYMENT_CHOICES?.find(
                                  (ec) => ec.value == jobDetails?.employment_type
                                )?.label
                              : t('jobs.employmentType') || 'Employment type'}
                            |{' '}
                            {jobDetails?.remote
                            ? t(WORKPLACE_TYPE?.find(
                                (ec) => ec.value == jobDetails?.remote
                              )?.translationKey) || WORKPLACE_TYPE?.find(
                                (ec) => ec.value == jobDetails?.remote
                              )?.label
                            : t('jobs.workplaceType') || 'Workplace type'}
                            {/* {jobDetails?.remote
                              ? WORKPLACE_TYPE?.find(
                                (ec) => ec.value == jobDetails?.remote
                              )?.label
                              : t('jobs.workplaceType') || 'Workplace type'} */}
                          </Text>
                        </HStack>
                      </VStack>

                      {jobDetails?.why_work_here && selectCompany && <Box>
                        <Heading as="h3" fontSize="md" fontWeight="400">
                          {t('jobs.whyWorkAt') || "Why work at"}{' '}
                          {selectCompany
                            ? selectCompany?.name
                            : 'Data Bridge Corp'}
                          ?
                        </Heading>
                        <Text fontSize="md" fontWeight="400" minH="24px">
                          {
                            jobDetails?.why_work_here
                              ? jobDetails?.why_work_here
                              : selectCompany && selectCompany?.why_work_here
                                ? selectCompany?.why_work_here
                                : ''
                          }
                          {/* {selectCompany && selectCompany?.why_work_here
                            ? selectCompany?.why_work_here
                            : jobDetails?.why_work_here
                            ? jobDetails?.why_work_here
                            : ''} */}
                        </Text>
                      </Box>}

                      {jobDetails?.skills?.length && <Stack>
                        <Text fontWeight="400">{t('applyJob.requiredSkills') || "Required Skills"}</Text>
                        <HStack flexWrap="wrap" minH="32px">
                          {jobDetails?.skills?.length ? (
                            <>
                              {jobDetails?.skills?.map((ben, benIndex) => (
                                <Tag
                                  py={2}
                                  px={3}
                                  borderRadius="full"
                                  key={benIndex}
                                >
                                  {ben?.name ? ben?.name : ben}
                                </Tag>
                              ))}
                            </>
                          ) : (
                            // <Tag py={2} px={3} borderRadius="full" key={1}>
                            //   Skill Name
                            // </Tag>
                            <></>
                          )}
                        </HStack>
                      </Stack>}

                      <Stack alignItems="flex-start">
                        <Button
                          variant="primary"
                          isDisabled={true}
                          borderRadius="full"
                        >
                          {t('applyJob.applyNow') || "Apply Now"}
                        </Button>
                      </Stack>

                      {jobDetails?.job_description ? (
                        <Box
                          dangerouslySetInnerHTML={{
                            __html: jobDetails?.job_description,
                          }}
                          mt={2}
                          className="jobDetailsDescription"
                        ></Box>
                      ) : (
                        <></>
                      )}
                    </VStack>
                  </Card>
                </Container>
              </Stack>}
            </>
          )}
        </Stack>
      )}
    </>
  );
};

export default Layout;
